{
  "offline_count": "உள்ளகத்தில் கிடைக்கும் உருப்படிகள்",
  "offline_navigation_unavailable": "குறிச்சொற்கள் மற்றும் மூலங்களை மாற்றுவது தற்போது இணைப்பில்லாத பயன்முறையில் கிடைக்கவில்லை.",
  "tags": "குறிச்சொற்கள்",
  "alltags": "அனைத்து குறிச்சொற்களும்",
  "timestamp": "{0,date}-{0,time}",
  "days": "{0,plural,zero {இன்று},one {நேற்று},other {# நாட்களுக்கு முன்பு}}",
  "star": "விண்மீன் இடு",
  "unstar": "விண்மீன் நீக்கு",
  "mark": "படித்தபடி குறி",
  "unmark": "படிக்காதது எனக் குறி",
  "load_img": "படங்களைக் காட்டு",
  "open_window": "திற",
  "next": "அடுத்தது",
  "share_native_label": "பங்கு",
  "share_diaspora_label": "புலம்பெயர்ந்தோரில் பகிர்",
  "share_twitter_label": "கீச்சகத்தில் பகிர்",
  "share_facebook_label": "முகநூலில் பகிர்",
  "share_mastodon_label": "குட்டைப் பருத்தியில் பகிர்",
  "share_pocket_label": "பையில் சேமி",
  "share_wallabag_label": "வாலபாக் சேமி",
  "share_wordpress_label": "சொல்அழுத்தில் பகிர்",
  "share_mail_label": "மின்னஞ்சலைப் பயன்படுத்தி பகிர்",
  "share_copy_label": "இடைநிலைப்பலகைக்கு இணைப்பை நகலெடு",
  "search_label": "தேடம் சொல்",
  "searchbutton": "தேடு",
  "searchremove": "தேடலை மறை",
  "refreshbutton": "மூலங்களைப் புதுப்பி",
  "settingsbutton": "அமைப்புகள்",
  "logoutbutton": "விடுபதிகை",
  "loginbutton": "புகுபதிகை",
  "sources": "மூலங்கள்",
  "sources_loading": "மூலங்களை ஏற்றுகிறது…",
  "no_sources": "எந்த மூலங்களும் கட்டமைக்கப்படவில்லை.",
  "source_add": "மூலத்தைச் சேர்",
  "source_opml": "அல்லது ஒபிஎம்எல் கோப்பை இறக்குமதி செய்",
  "source_export": "ஏற்றுமதி மூலங்கள்",
  "source_edit": "தொகு",
  "source_filter": "வடிப்பி",
  "source_menu": "மேலும் செயல்கள்",
  "source_browse": "உலாவு",
  "source_delete": "நீக்கு",
  "source_warn": "உண்மையில் இந்த மூலத்தை நீக்கவா?",
  "source_deleting": "மூலத்தை நீக்குதல்…",
  "source_warn_cancel_dirty": "சேமிக்காத மாற்றங்களை நிராகரிக்கவா?",
  "source_new": "புதிய சேமிக்கப்படாத மூல",
  "source_title": "தலைப்பு",
  "source_autotitle_hint": "தலைப்பைப் பெற காலியாக விடு",
  "source_tags": "குறிச்சொற்கள்",
  "source_pwd_placeholder": "மாற்றப்படவில்லை",
  "source_comma": "காற்புள்ளியால் பிரிந்தது",
  "source_select": "மூலத்தைத் தேர்ந்தெடு",
  "source_params_loading": "அளவுருக்களை ஏற்றுகிறது…",
  "source_type": "வகை",
  "source_save": "சேமி",
  "source_cancel": "நீக்கறல்",
  "source_saving": "மூல மாற்றங்களைச் சேமிக்கிறது…",
  "source_saved": "சேமிக்கப்பட்டது",
  "source_last_post": "கடைசி இடுகை பார்த்தது",
  "source_refresh": "இந்த மூலத்தைப் புதுப்பி",
  "source_go_to_settings": "அமைப்புகளில் திற",
  "sources_leaving_unsaved_prompt": "சேமிக்கப்படாத மூல மாற்றங்களுடன் அமைப்புகளை விடலாமா?",
  "tag_change_color_button_title": "நிறத்தை மாற்று",
  "entries_loading": "உள்ளீடுகளை ஏற்றுகிறது…",
  "no_entries": "உள்ளீடுகள் எதுவும் கிடைக்கவில்லை",
  "login_error_generic": "உள்நுழைய முடியவில்லை: {errorMessage}",
  "error_check_log_file": "பிழை ஏற்பட்டது, தயவுசெய்து “{0}” பதிவுக் கோப்பை சரிபார்.",
  "error_check_system_logs": "பிழை ஏற்பட்டது, உங்கள் கணினி பதிவுகளைச் சரிபார்.",
  "error_unwritable_logs": "பதிவுகள் எழுத முடியவில்லை.",
  "streamerror": "உருப்படிகள் ஏற்றப்படவில்லை, மீண்டும் ஏற்றுமா?",
  "reload_list": "பட்டியல் மீண்டும் ஏற்று",
  "sources_refreshed": "மூலங்கள் புதுப்பிக்கப்பட்டது",
  "error_session_expired": "அமர்வு காலாவதியானது",
  "error_add_source": "மூலத்தைச் சேர்க்க முடியவில்லை:",
  "error_edit_source": "மூல மாற்றங்களைச் சேமிக்க முடியவில்லை:",
  "error_delete_source": "மூலத்தை நீக்க முடியவில்லை:",
  "error_load_tags": "குறிச்சொற்களை ஏற்ற முடியவில்லை:",
  "error_unknown_tag": "தெரியாத குறிச்சொல்:",
  "error_sync": "சேவையகத்திலிருந்து கடைசி மாற்றங்களை ஒத்திசைக்க முடியவில்லை:",
  "error_offline_storage": "இணைப்பில்லாத சேமிப்பக பிழை: {0}. மீண்டும் ஏற்றுவது உதவக்கூடும். இப்போதைக்கு இணைப்பில்லாததை முடக்குகிறது.",
  "markread": "படித்தபடி குறி",
  "filter": "வடிப்பி",
  "newest": "புதியது",
  "unread": "படிக்காதது",
  "starred": "விண்மீன் இடப்பட்டது",
  "online_count": "சேவையகத்தில் கிடைக்கும் உருப்படிகள்",
  "hours": "{0,plural,one {1 மணிநேரம்},other {# மணிநேரங்கள்}} முன்பு",
  "minutes": "{0,plural,one {1 நிமையம்},other {# நிமையங்கள்}} முன்பு",
  "seconds": "{0,plural,one {1 நொடி},other {# நொடிகள்}} முன்பு",
  "more": "மேலும்",
  "login": "புகுபதிகை",
  "login_in_progress": "உள்நுழைய முயற்சிக்கிறது…",
  "login_username": "பயனர்பெயர்",
  "login_password": "கடவுச்சொல்",
  "login_invalid_credentials": "தவறான பயனர்பெயர்/கடவுச்சொல்",
  "login_offline": "இணைப்பில்லாத சேமிப்பு",
  "no_title": "தலைப்பு இல்லை",
  "experimental": "சோதனை",
  "error": "பிழை ஏற்பட்டது",
  "error_unauthorized": "தொடர {link_begin}உள்நுழைக{link_end}.",
  "app_update": "செல்போச் புதுப்பிக்கப்பட்டுள்ளது, தயவுசெய்து மீண்டும் ஏற்று",
  "app_reload": "மறுஏற்று",
  "error_unknown_source": "தெரியாத மூல அடையாளம்:",
  "error_mark_items": "புலப்படும் அனைத்து பொருட்களையும் குறிக்க முடியாது:",
  "error_mark_item": "உருப்படியைக் குறிக்க/குறிநீக்க முடியாது:",
  "error_star_item": "விண்மீன் இட/நீக்க முடியாத உருப்படி:",
  "error_logout": "வெளியேற முடியவில்லை:",
  "error_loading": "ஏற்றுதல் பிழை:",
  "error_loading_stats": "வழிசெலுத்திய புள்ளிவிவரங்களை ஏற்ற முடியாது:",
  "error_saving_color": "புதிய வண்ணத்தைச் சேமிக்க முடியாது:",
  "error_refreshing_source": "மூலங்களைப் புதுப்பிக்க முடியாது:",
  "error_invalid_subsection": "தவறான துணைபகுதி:",
  "error_configuration": "உள்ளமைவை ஏற்ற முடியவில்லை.",
  "error_share_native_abort": "உருப்படியைப் பகிர முடியவில்லை -பங்கு இலக்குகள் இல்லை, அல்லது நீங்கள் அதைத் தள்ளுபடி செய்தீர்கள்.",
  "close_entry": "மூடு",
  "error_offline_storage_not_available": "இணைப்பில்லாத சேமிப்பு கிடைக்கவில்லை. உங்கள் வலை உலாவி {0} அட்டவணைப்படுத்தப்பட்ட தரவுத்தளம் பநிஇ {1} ஐ ஆதரிக்கிறது என்பதை உறுதிப்படுத்திக் கொள்ளுங்கள், மேலும் நீங்கள் கூகிள் நிறமி அடிப்படையிலான உலாவியைப் பயன்படுத்துகிறீர்கள் என்றால், நீங்கள் மறைநிலை பயன்முறையில் செல்போசை இயக்கவில்லை என்பதை உறுதிப்படுத்தவும்.",
  "error_share_native": "உருப்படியைப் பகிர முடியவில்லை.",
  "info_url_copied": "முகவரி இடைநிலைப்பலகைக்கு நகலெடுக்கப்பட்டது.",
  "article_actions": "செயல்கள்",
  "article_reading_time": "{0} நிமையம் படித்தது"
}
